import { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import LoadingScreen from "./Components/LoadingScreen";
import Home from "./Pages/Home";

import Footer from "./Components/Footer";
import FAQPage from "./Pages/faq";

import Whoiscoming from "./Components/Whoiscoming";
import PastPartners from "./Components/PastPartners";
import SponsorUs from "./Components/SponsorUs";
import Shop from "./Components/Shop";
import Hackathon from "./Components/Hackathon";
import MediaAboutUs from "./Components/MediaAboutUs"


function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading (e.g., fetching data, assets, etc.)
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000); // Adjust delay as needed

    return () => clearTimeout(timer);
  }, []);
  return (
    <div className="overflow-hidden">
      <LoadingScreen isLoading={isLoading} />

      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/faq" element={<FAQPage />} />

        <Route path='/past-partners' element={<PastPartners/>}/>
        <Route path="/who-attended" element={<Whoiscoming />} />

        <Route path="/media-about-us" element={<MediaAboutUs />} />
       
        <Route path="/sponsorUs" element={<SponsorUs />} />
        <Route path="/hackathon" element={<Hackathon />} />

         <Route path="/shop" element={<Shop />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
